import { render, staticRenderFns } from "./company_info.vue?vue&type=template&id=ea355614&scoped=true&"
import script from "./company_info.vue?vue&type=script&lang=js&"
export * from "./company_info.vue?vue&type=script&lang=js&"
import style0 from "./company_info.vue?vue&type=style&index=0&id=ea355614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea355614",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea355614')) {
      api.createRecord('ea355614', component.options)
    } else {
      api.reload('ea355614', component.options)
    }
    module.hot.accept("./company_info.vue?vue&type=template&id=ea355614&scoped=true&", function () {
      api.rerender('ea355614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/counterparty/company_info.vue"
export default component.exports